import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { Courier, CourierService } from '../../../interfaces/Courier'

export const getCouriers = (
  filters?: Filter[],
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.CourierApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters && filters.length > 0) {
    filters.forEach((filter) => {
      url.searchParams.set(filter.key, filter.value)
    })
  }

  return axios.get(url.toString())
}

export const deleteCourier = (courierId: number) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}`)
  return axios.delete(url.toString())
}

export const postCourier = (dto: Courier) => {
  const url = new URL(`${ApiConfig.CourierApi}`)
  return axios.post(url.toString(), dto)
}

export const getCourier = (courierId: number) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}`)
  return axios.get(url.toString())
}

export const putCourier = (courierId: number, dto: Partial<Courier>) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}`)
  return axios.put(url.toString(), dto)
}

export const postCourierService = (
  courierId: number,
  dto: Partial<CourierService>
) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}/service`)
  return axios.post(url.toString(), dto)
}

export const putCourierService = (
  courierId: number,
  courierServiceId: number,
  dto: Partial<CourierService>
) => {
  const url = new URL(
    `${ApiConfig.CourierApi}/${courierId}/service/${courierServiceId}`
  )
  return axios.put(url.toString(), dto)
}

export const deleteCourierService = (
  courierId: number,
  courierServiceId: number
) => {
  const url = new URL(
    `${ApiConfig.CourierApi}/${courierId}/service/${courierServiceId}`
  )
  return axios.delete(url.toString())
}

// obtiene todos los Courier y Courier Services Optimizado para autocompletar filtros de busquedas.
export const getAllListCouriers = (onlyActive?: boolean) => {
  const url = new URL(`${ApiConfig.CourierApi}/GetList`)
  url.searchParams.set('resumeinfo', 'true')
  if (onlyActive !== undefined) {
    url.searchParams.set('onlyActive', onlyActive.toString())
  }
  return axios.get(url.toString())
}

